import Link from "next/link";

import IconSound from "assets/svgs/sound.svg";
import IconSource from "assets/svgs/source.svg";

export default function EventSources({ relatedSources }) {
  return (
    <section className="pt-4">
      <h3 className="font-semibold">Sources of Information</h3>
      <ul className="md:gap-4 md:grid md:grid-cols-2 mt-2">
        {relatedSources.map((source) => {
          const { url, source_name, title, type } = source;

          return (
            <li className="flex items-center" key={title}>
              {type && (
                <i aria-hidden="true" className="flex-shrink-0 text-gray-400">
                  {type === "Podcast" ? (
                    <IconSound width="18" />
                  ) : (
                    <IconSource width="18" />
                  )}
                </i>
              )}
              <div className="pl-2 text-xs">
                {url && (
                  <Link href={url && url}>
                    <a
                      className="block font-semibold text-red"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {title}
                    </a>
                  </Link>
                )}
                <small className="text-xs">{source_name && source_name}</small>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
